import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const SecurityProLayout = lazy(() =>
  import('../components/security-pro/SecurityProLayout').then((m) => ({ default: m.SecurityProLayout }))
)
const SecProHubPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.HubPage }))
)
const SecProCockpitPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.CockpitPage }))
)
const SecProScorePage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ScorePage }))
)
const SecProPosturePage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.PosturePage }))
)
const SecProSocDashboardPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SocDashboardPage }))
)
const SecProIncidentsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.IncidentsPage }))
)
const SecProIncidentDetailPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.IncidentDetailPage }))
)
const SecProThreatIntelPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ThreatIntelPage }))
)
const SecProAlertsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.AlertsPage }))
)
const SecProVulnsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.VulnsPage }))
)
const SecProVulnDetailPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.VulnDetailPage }))
)
const SecProIamPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.IamPage }))
)
const SecProControlsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecProControlsPage }))
)
const SecProEncryptionPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.EncryptionPage }))
)
const SecProBcpPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.BcpPage }))
)
const SecProExercisesPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ExercisesPage }))
)
const SecProExerciseDetailPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ExerciseDetailPage }))
)
const SecProDrPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.DrPage }))
)
const SecProFrameworksPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecProFrameworksPage }))
)
const SecProIso27001Page = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.Iso27001Page }))
)
const SecProSoc2Page = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.Soc2Page }))
)
const SecProReportExecPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ReportExecPage }))
)
const SecProReportOpsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ReportOpsPage }))
)
const SecProIntegrationPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecProIntegrationPage }))
)
const SecProAuditTrailPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecProAuditTrailPage }))
)
const SecProTemplatesPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecProTemplatesPage }))
)
const SecProSettingsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecProSettingsPage }))
)
const SecProOutilsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecProOutilsPage }))
)
const SecProAccessReviewPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.AccessReviewPage }))
)
const SecProBiaAnalysisPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.BiaAnalysisPage }))
)
const SecProCrisisEventsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.CrisisEventsPage }))
)
const SecProCyberInsurancePage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.CyberInsurancePage }))
)
const SecProCyberRiskQuantPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.CyberRiskQuantPage }))
)
const SecProDORACompliancePage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.DORACompliancePage }))
)
const SecProDigitalRiskPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.DigitalRiskPage }))
)
const SecProInsiderRiskPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.InsiderRiskPage }))
)
const SecProOperationalResiliencePage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.OperationalResiliencePage }))
)
const SecProSecurityAwarenessPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecurityAwarenessPage }))
)
const SecProSecurityPostureAIPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecurityPostureAIPage }))
)
const SecProIncidentPlaybookPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.IncidentPlaybookPage }))
)
const SecProAttackSurfacePage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.AttackSurfacePage }))
)
const SecProSecurityPostureCopilotPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.SecurityPostureCopilotPage }))
)
const SecProZeroTrustScorecardPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ZeroTrustScorecardPage }))
)
const SecProThreatHuntingPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.ThreatHuntingPage }))
)
const SecProCcmCockpitPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.CcmCockpitPage }))
)
const SecProCcmControlTestsPage = lazy(() =>
  import('../pages/security-pro').then((m) => ({ default: m.CcmControlTestsPage }))
)

export const securityProRoutes: RouteObject[] = [
  {
    path: '/security-pro',
    element: <SecurityProLayout />,
    children: [
      { index: true, element: <SecProHubPage /> },

      { path: 'hub', element: <SecProHubPage /> },
      { path: 'cockpit', element: <SecProCockpitPage /> },
      { path: 'score', element: <SecProScorePage /> },
      { path: 'posture', element: <SecProPosturePage /> },
      { path: 'soc', element: <SecProSocDashboardPage /> },
      // Profile-MD aliases for CISO workflow
      { path: 'soc/dashboards', element: <SecProSocDashboardPage /> },
      { path: 'threats/intel', element: <SecProThreatIntelPage /> },
      { path: 'vulnerabilities', element: <SecProVulnsPage /> },
      { path: 'controls/library', element: <SecProControlsPage /> },
      { path: 'controls/assess', element: <SecProControlsPage /> },
      { path: 'pentest/findings', element: <SecProControlsPage /> },
      { path: 'incidents', element: <SecProIncidentsPage /> },
      { path: 'incidents/log', element: <SecProIncidentsPage /> },
      { path: 'incidents/:id', element: <SecProIncidentDetailPage /> },
      { path: 'threat-intel', element: <SecProThreatIntelPage /> },
      { path: 'alerts', element: <SecProAlertsPage /> },
      { path: 'vulns', element: <SecProVulnsPage /> },
      { path: 'vulns/:id', element: <SecProVulnDetailPage /> },
      { path: 'iam', element: <SecProIamPage /> },
      { path: 'controls', element: <SecProControlsPage /> },
      { path: 'encryption', element: <SecProEncryptionPage /> },
      { path: 'bcp', element: <SecProBcpPage /> },
      { path: 'exercises', element: <SecProExercisesPage /> },
      { path: 'exercises/:id', element: <SecProExerciseDetailPage /> },
      { path: 'dr', element: <SecProDrPage /> },
      { path: 'frameworks', element: <SecProFrameworksPage /> },
      { path: 'iso27001', element: <SecProIso27001Page /> },
      { path: 'soc2', element: <SecProSoc2Page /> },
      { path: 'report-exec', element: <SecProReportExecPage /> },
      { path: 'report-ops', element: <SecProReportOpsPage /> },
      { path: 'integration', element: <SecProIntegrationPage /> },
      { path: 'audit-trail', element: <SecProAuditTrailPage /> },
      { path: 'templates', element: <SecProTemplatesPage /> },
      { path: 'settings', element: <SecProSettingsPage /> },
      { path: 'outils', element: <SecProOutilsPage /> },
      { path: 'access-review', element: <SecProAccessReviewPage /> },
      { path: 'bia-analysis', element: <SecProBiaAnalysisPage /> },
      { path: 'crisis-events', element: <SecProCrisisEventsPage /> },
      { path: 'cyber-insurance', element: <SecProCyberInsurancePage /> },
      { path: 'cyber-risk-quant', element: <SecProCyberRiskQuantPage /> },
      { path: 'dora-compliance', element: <SecProDORACompliancePage /> },
      { path: 'digital-risk', element: <SecProDigitalRiskPage /> },
      { path: 'insider-risk', element: <SecProInsiderRiskPage /> },
      { path: 'operational-resilience', element: <SecProOperationalResiliencePage /> },
      { path: 'awareness', element: <SecProSecurityAwarenessPage /> },
      { path: 'security-posture-ai', element: <SecProSecurityPostureAIPage /> },
      { path: 'incident-playbook', element: <SecProIncidentPlaybookPage /> },
      { path: 'attack-surface', element: <SecProAttackSurfacePage /> },
      { path: 'security-posture-copilot', element: <SecProSecurityPostureCopilotPage /> },
      { path: 'zero-trust-scorecard', element: <SecProZeroTrustScorecardPage /> },
      { path: 'threat-hunting', element: <SecProThreatHuntingPage /> },
      // CCM — Continuous Controls Monitoring
      { path: 'ccm', element: <SecProCcmCockpitPage /> },
      { path: 'ccm/control-tests', element: <SecProCcmControlTestsPage /> },
    ],
  },
]
